export const TOGGLE_ALL = "Toggle all";
